export const URL_QUERY = {
  COMPANY_ID: 'companyId',
  ENTERPRISE_ID: 'enterpriseId',
  AICORE_ID: 'aicoreId',
  PROJECT_ID: 'projectId'
}